import React,{Suspense, useRef, useState} from 'react'
import emailjs from '@emailjs/browser'
import { Canvas } from '@react-three/fiber';
import Bullet from '../models/Bullet'
import Loader from '../components/Loader'
import useAlert from '../hooks/useAlert';
import Alert from '../components/Alert';

const Contact = () => {
  const formRef=useRef(null);
  const [form, setForm] = useState({name:'',email:'',message:''});
  const [isLoading,setIsLoading]=useState(false);
  const [currentAnimation, setCurrentAnimation] = useState('Static Pose');

  const {alert,showAlert,hideAlert}=useAlert();

  const handleChange=(e)=>{
    setForm({...form,[e.target.name]:e.target.value});
  };
  const handleFocus=(e)=>{
    setCurrentAnimation('Default Take');
  };
  const handleBlur=()=>{
    setCurrentAnimation('Static Pose')
  };
  const handleSubmit=(e)=>{
    e.preventDefault();
    setIsLoading(true);
    setCurrentAnimation('Default Take');
    emailjs.send(
      process.env.REACT_APP_EMAILJS_SERVICE_ID,
      process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
      {
        from_name:form.name,
        to_name:"Sairam",
        from_email:form.email,
        to_email:'sairamnst1234@gmail.com',
        message:form.message
      },
      process.env.REACT_APP_EMAILJS_PUBLIC_KEY
    ).then(()=>{
      setIsLoading(false);
      showAlert({show:true,text:'Message sent successfully!',type:'success'})

      setTimeout(()=>{
        hideAlert();
        setCurrentAnimation('Static Pose');
        setForm({name:'',email:'',message:''});
      },[4000])



    }).catch((error)=>{
      setIsLoading(false);
      setCurrentAnimation('Static Pose')
      console.log(error);
      showAlert({show:true,text:'I didn\'t receive your message',type:'danger'})
    })
  };
  return (
    <section className='relative flex lg:flex-row flex-col max-container h-[100vh]'>
      {alert.show && <Alert {...alert}/>}
      <div className='flex-1 min-w-[50%] flex flex-col'>
        <h1 className='head-text'>
          Get in Touch
        </h1>
        <form 
          className='w-full flex flex-col gap-7 mt-14'
          onSubmit={handleSubmit}
        >
          <label className='text-black-500 font-semibold'>
            Name
            <input 
              type="text"
              name="name"
              className='input'
              placeholder='Sairam'
              required
              value={form.name}
              onChange={handleChange}
              onFocus={handleFocus}
              onBlur={handleBlur}
            >
            </input>
          </label>
          <label className='text-black-500 font-semibold'>
            Email
            <input 
              type="email"
              name="email"
              className='input'
              placeholder='sairamnst1234@gmail.com'
              required
              value={form.email}
              onChange={handleChange}
              onFocus={handleFocus}
              onBlur={handleBlur}
            >
            </input>
          </label>
          <label className='text-black-500 font-semibold'>
            Message
            <textarea 
              name="message"
              rows={4}
              className='textarea'
              placeholder='How can I help you?'
              required
              value={form.message}
              onChange={handleChange}
              onFocus={handleFocus}
              onBlur={handleBlur}
            >
            </textarea>
          </label>
          <button
            type="submit"
            className='btn'
            disabled={isLoading}
            onFocus={handleFocus}
            onBlur={handleBlur}
          >
            {isLoading?'Sending...':'Send Message'}
          </button>
        </form>
      </div>

      <div className='lg:w-1/2 w-full lg:h-auto md:h-[550px] h-[350px]'>
        <Canvas camera={{
            position:[0,0,5],
            fov:75,
            near:0.1,
            far:1000,
          }}
        >
          <directionalLight intensity={2.5} position={[0,4,1]}/>
          <ambientLight intensity={0.5}/>
          <Suspense fallback={<Loader/>}>
            <Bullet
              currentAnimation={currentAnimation}
              position={[1,-2,0]}
              rotation={[0,1,0]}
              scale={[0.5,0.8,0.5]}
            />
          </Suspense>
        </Canvas>
      </div>
    </section>
  )
}

export default Contact